import React from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import loadable from "@loadable/component";

const Header = loadable(() => import("../components/Header"));
const Footer = loadable(() => import("../components/Footer"));
const AppPromotionBanner = loadable(() => import("../components/AppPromotionBanner"));

const AuthContainer = () => {
	const { config, loaded } = useSelector((state) => state.Home);
	const appPromotionBannerValue = Array.isArray(config?.app_promotion_banner_enabled)
		? config.app_promotion_banner_enabled[0]
		: config?.app_promotion_banner_enabled;
	const isAppPromotionBannerEnabled = String(appPromotionBannerValue ?? "true").toLowerCase() === "true";

	return (
		<>
			<div className="layout_wrapper">
				<Header />
				{loaded && isAppPromotionBannerEnabled && <AppPromotionBanner />}
				<div className="panel_wrp">
					<Outlet />
				</div>
				<Footer />
			</div>
		</>
	);
};

export default AuthContainer;
